// Utilitaire pour formater les états d'objets en français
export const formatEtat = (etat: string): string => {
  const etatMap: Record<string, string> = {
    'bon': 'Bon',
    'à réparer': 'À réparer',
    'incomplet': 'Incomplet',
    'neuf': 'Neuf',
    'usé': 'Usé',
    'hs': 'Hors service',
    // Support des anciens états en majuscules
    'BON': 'Bon',
    'A_REPARER': 'À réparer',
    'INCOMPLET': 'Incomplet',
    'HS': 'Hors service',
  };
  
  return etatMap[etat] || etat;
};

// Fonction pour obtenir la couleur associée à un état
export const getEtatColor = (etat: string): string => {
  const colorMap: Record<string, string> = {
    'bon': 'text-green-600 bg-green-100',
    'à réparer': 'text-yellow-600 bg-yellow-100',
    'incomplet': 'text-orange-600 bg-orange-100',
    'neuf': 'text-blue-600 bg-blue-100',
    'usé': 'text-gray-600 bg-gray-100',
    'hs': 'text-red-600 bg-red-100',
    // Support des anciens états en majuscules
    'BON': 'text-green-600 bg-green-100',
    'A_REPARER': 'text-yellow-600 bg-yellow-100',
    'INCOMPLET': 'text-orange-600 bg-orange-100',
    'HS': 'text-red-600 bg-red-100',
  };
  
  return colorMap[etat] || 'text-gray-600 bg-gray-100';
};

